import React from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F8F5F2]">
      {/* Hero Section - Powerful & Centered */}
      <section className="relative w-full min-h-[auto] md:min-h-screen flex flex-col md:flex-row items-center justify-center bg-[#E8E0DA]">
        {/* Mobile: Image container with contain behavior */}
        <div className="relative w-full md:hidden">
          <div className="w-full aspect-[1280/659]">
            <img
              src="https://static.wixstatic.com/media/35f824_e35b060a2317462abc3033388b66baa2~mv2.jpg/v1/fill/w_1280,h_659,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/The%20Injector%20Syd%20-%20Palm%20Springs%20Greeting%20Card.jpg"
              alt="Greetings from The Injector Syd Las Vegas"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        
        {/* Desktop: Full cover background */}
        <div className="hidden md:block absolute inset-0">
          <img
            src="https://static.wixstatic.com/media/35f824_e35b060a2317462abc3033388b66baa2~mv2.jpg/v1/fill/w_1280,h_659,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/The%20Injector%20Syd%20-%20Palm%20Springs%20Greeting%20Card.jpg"
            alt="Greetings from The Injector Syd Las Vegas"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        {/* Mobile text content */}
        <div className="md:hidden w-full bg-[#E8E0DA] py-12 px-6">
          <div className="text-center max-w-xl mx-auto">
            <h1 className="font-display text-4xl font-bold text-[#1A1A1A] mb-6 leading-[1.05] tracking-tight">
              Subtle Enhancements.<br />Confident Results.
            </h1>
            <p className="font-display italic text-lg text-[#1A1A1A]/80 mb-10 font-normal leading-relaxed">
              Advanced aesthetic injectables and facial rejuvenation in Las Vegas.
            </p>
            <a
              href="tel:+17022835858"
              className="inline-block px-10 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl hover:scale-105"
            >
              Book Consultation
            </a>
          </div>
        </div>

        {/* Desktop text content */}
        <div className="hidden md:block relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="font-display text-8xl lg:text-9xl font-bold text-white mb-10 leading-[1.05] tracking-tight">
            Subtle Enhancements.<br />Confident Results.
          </h1>
          <p className="font-display italic text-3xl text-white/95 mb-16 max-w-3xl mx-auto font-normal leading-relaxed">
            Advanced aesthetic injectables and facial rejuvenation in Las Vegas.
          </p>
          <a
            href="tel:+17022835858"
            className="inline-block px-14 py-6 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl hover:scale-105"
          >
            Book Consultation
          </a>
        </div>
      </section>

      {/* Palm Trees Section */}
      <section className="relative w-full bg-white">
        <div className="max-w-7xl mx-auto px-6 py-32">
          <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.wixstatic.com/media/c9ecc717505843e0adbbdf3a6195f4db.jpg/v1/fill/w_1280,h_653,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Palm%20Trees.jpg"
              alt="Palm Trees"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="bg-[#F8F5F2] py-40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-28">
            <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-12 tracking-tight">
              About
            </h2>
            <div className="w-32 h-[2px] bg-[#C4A092] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-28 items-center">
            {/* Left - Image */}
            <div className="flex justify-center">
              <div className="w-full max-w-lg h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/0ed3b04a2635611b13ce47ba00f6a147.jpg"
                  alt="The Injector Syd Clinic"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right - Content */}
            <div className="space-y-10">
              <h3 className="font-display italic text-4xl md:text-5xl font-normal text-[#C4A092] tracking-wide leading-tight">
                Welcome to The Injector Syd
              </h3>

              <p className="font-sans text-lg text-[#1A1A1A]/75 leading-[1.8] font-medium">
                Located in the heart of Las Vegas, The Injector Syd is your premier destination for
                aesthetic medicine and wellness treatments. We specialize in providing natural-looking
                results that enhance your unique beauty while maintaining your authentic self.
              </p>

              <p className="font-sans text-lg text-[#1A1A1A]/75 leading-[1.8] font-medium">
                Led by Sydney Mallad, BSN-RN, our practice combines medical expertise with an artistic
                eye to deliver personalized treatments tailored to your individual goals. With years
                of experience in aesthetic medicine, we pride ourselves on creating a comfortable,
                professional environment where you can feel confident in your care.
              </p>

              <p className="font-sans text-lg text-[#1A1A1A]/75 leading-[1.8] font-medium">
                From neuromodulators and dermal fillers to weight loss solutions and IV therapy, we
                offer a comprehensive range of services designed to help you look and feel your
                best. Every treatment is performed with precision, care, and attention to detail.
              </p>

              <div className="pt-10">
                <a
                  href="tel:+17022835858"
                  className="inline-block px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-lg hover:shadow-xl hover:scale-105"
                >
                  Schedule Your Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Your Injector Section */}
      <section className="bg-white py-40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-28">
            <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-12 tracking-tight">
              Meet Your Injector
            </h2>
            <div className="w-32 h-[2px] bg-[#C4A092] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-28 items-center">
            {/* Left - Provider Photo */}
            <div className="flex justify-center">
              <div className="relative">
                <div className="w-full max-w-md h-[650px] rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="https://static.wixstatic.com/media/35f824_e5187c637d5e4558b7a3f2b12d369c40~mv2.jpg/v1/crop/x_204,y_43,w_787,h_1037/fill/w_362,h_477,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Snapinsta_app_386341650_1514606372691405_7012477767250135035_n_1080.jpg"
                    alt="Sydney Mallad, BSN-RN"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Right - Bio Content */}
            <div className="space-y-8">
              <h3 className="font-display text-5xl md:text-6xl font-bold text-[#1A1A1A] tracking-tight leading-tight">
                Sydney Mallad, BSN-RN
              </h3>
              <p className="font-display italic text-2xl text-[#C4A092] font-normal">
                Founder &amp; Lead Aesthetic Injector
              </p>

              <p className="font-sans text-lg text-[#1A1A1A]/75 leading-[1.8] font-medium">
                Sydney Mallad is a Board-Certified Registered Nurse with a Bachelor of Science in
                Nursing (BSN) and specialized training in aesthetic medicine. With a passion for
                enhancing natural beauty and helping clients feel confident in their own skin,
                Sydney has dedicated her career to mastering the art and science of injectable
                treatments.
              </p>

              <p className="font-sans text-lg text-[#1A1A1A]/75 leading-[1.8] font-medium">
                Her approach is rooted in precision, artistry, and a deep understanding of facial
                anatomy. Sydney believes that every face is unique and deserves a customized
                treatment plan that honors individual features while achieving harmonious,
                natural-looking results.
              </p>

              <div className="pt-8 space-y-6">
                {[
                  'Board-Certified Registered Nurse (BSN-RN)',
                  'Advanced Training in Aesthetic Injectables',
                  'Specialized in Natural-Looking Results',
                ].map((text, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <i className="ri-checkbox-circle-fill text-[#C4A092] text-2xl w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
                    <p className="font-sans text-lg text-[#1A1A1A]/75 font-medium">{text}</p>
                  </div>
                ))}
              </div>

              <div className="pt-10">
                <a
                  href="tel:+17022835858"
                  className="inline-block px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-lg hover:shadow-xl hover:scale-105"
                >
                  Book With Sydney
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Check Our Prices Section */}
      <section className="bg-[#F8F5F2] py-40">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-14 tracking-tight">
            Check Our Prices
          </h2>
          <div className="w-32 h-[2px] bg-[#C4A092] mx-auto mb-16"></div>
          <p className="font-display italic text-2xl text-[#1A1A1A]/75 mb-16 font-normal leading-relaxed">
            View our complete service menu with transparent pricing for all treatments
          </p>
          <Link
            to="/menu"
            className="inline-block px-14 py-6 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl hover:scale-105"
          >
            View Full Menu
          </Link>
        </div>
      </section>

      {/* Client Experiences Section */}
      <section className="bg-white py-40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-28">
            <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-12 tracking-tight">
              Client Experiences
            </h2>
            <div className="w-32 h-[2px] bg-[#C4A092] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Testimonial 1 - Lip Filler */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "I had always been hesitant about lip filler because I feared looking artificial. After seeing her work, I felt completely confident. My results are balanced, refined, and beautifully natural."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Vicky M.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Lip Filler Client</p>
              </div>
            </div>

            {/* Testimonial 2 - Dysport */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "The Dysport treatment exceeded my expectations. My forehead lines softened beautifully without looking frozen. I still have full expression, just smoother and more refreshed."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Michelle P.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Dysport Client</p>
              </div>
            </div>

            {/* Testimonial 3 - Cheek Filler */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "What sets her apart is restraint. She builds volume gradually to preserve elegance and proportion. The result is soft, structured, and sophisticated."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Alyssa R.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Cheek Filler Client</p>
              </div>
            </div>
          </div>

          {/* Second Row of Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Testimonial 4 - Weight Loss */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "The Semaglutide program changed my life. I've lost 35 pounds and feel incredible. Sydney's guidance and support throughout the journey made all the difference."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Jennifer K.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Weight Loss Client</p>
              </div>
            </div>

            {/* Testimonial 5 - Laser Hair Removal */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "After years of waxing, laser hair removal was the best decision. The treatments were comfortable and the results are amazing. Smooth skin without the hassle."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Rachel S.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Laser Hair Removal Client</p>
              </div>
            </div>

            {/* Testimonial 6 - Lip Filler */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "My partner complimented the shape of my lips and was surprised to learn they were enhanced. That level of subtle artistry speaks for itself."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Remy L.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Lip Filler Client</p>
              </div>
            </div>
          </div>

          {/* Third Row of Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Testimonial 7 - Morpheus8 */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "Morpheus8 transformed my skin texture and tightness. The results are incredible—my face looks lifted and rejuvenated without surgery. Worth every penny."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Diana M.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Morpheus8 Client</p>
              </div>
            </div>

            {/* Testimonial 8 - IV Therapy */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "The IV therapy gave me an instant energy boost. I felt hydrated, refreshed, and ready to take on the week. It's now part of my monthly wellness routine."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Lauren B.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">IV Therapy Client</p>
              </div>
            </div>

            {/* Testimonial 9 - Lip Filler */}
            <div className="bg-[#F8F5F2] p-12 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A092] text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-display italic text-xl text-[#1A1A1A]/80 leading-[1.7] mb-10 font-normal">
                "There is a clear difference between filler and artistry. She enhances without overpowering."
              </p>
              <div className="border-t border-[#C4A092]/20 pt-7">
                <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-wide">Samantha T.</p>
                <p className="font-sans text-sm text-[#1A1A1A]/60 mt-2 font-medium">Lip Filler Client</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services List Section */}
      <section className="bg-[#F8F5F2] py-40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-start">
            {/* Left Side - Image and Title */}
            <div className="flex flex-col items-center">
              <div className="w-80 h-80 mb-14 flex items-center justify-center">
                <img
                  src="https://static.wixstatic.com/media/35f824_218ef5c24f084f60bbea826054ad3636~mv2.jpg/v1/fill/w_379,h_404,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/lips%20single%20line_edited_edited_edited.jpg"
                  alt="Line art illustration"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="font-display italic text-6xl font-normal text-[#C4A092] text-center leading-tight">
                Our<br />Services
              </h3>
            </div>

            {/* Right Side - Services List */}
            <div className="space-y-12 pt-16">
              {['01  Neuromodulators', '02  Dermal Fillers', '03  Weight Loss', '04  IV Therapy'].map(
                (text, idx) => (
                  <div key={idx} className="border-b border-[#C4A092]/30 pb-10 group cursor-pointer">
                    <p className="font-sans text-base font-semibold text-[#1A1A1A] tracking-[0.2em] group-hover:text-[#C4A092] transition-colors">
                      {text}
                    </p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Provider Intro Section */}
      <section className="bg-white py-40">
        <div className="max-w-4xl mx-auto px-6 text-center mb-24">
          <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-12 tracking-tight">
            Sydney Mallad, BSN-RN
          </h2>
          <div className="w-32 h-[2px] bg-[#C4A092] mx-auto"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0 rounded-2xl overflow-hidden shadow-2xl">
            {/* Left - Sage Green Background */}
            <div className="bg-brand-sage h-[600px] flex items-center justify-center">
              <p className="font-display italic text-4xl text-white tracking-wider font-normal">
                The Injector Syd
              </p>
            </div>

            {/* Center - Provider Photo */}
            <div className="bg-brand-dusty-pink h-[600px] flex items-center justify-center relative">
              <div className="absolute inset-0 flex items-end justify-center pb-20">
                <div className="w-80 h-[420px] rounded-full overflow-hidden shadow-2xl">
                  <img
                    src="https://static.wixstatic.com/media/35f824_e5187c637d5e4558b7a3f2b12d369c40~mv2.jpg/v1/crop/x_204,y_43,w_787,h_1037/fill/w_362,h_477,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Snapinsta_app_386341650_1514606372691405_7012477767250135035_n_1080.jpg"
                    alt="Sydney Mallad"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Right - Pink Background with Cactus */}
            <div className="bg-brand-rose/40 h-[600px] relative">
              <img
                src="https://static.wixstatic.com/media/35f824_e9a397609d754c18be73d10a8f148fd2~mv2.jpg/v1/fill/w_640,h_972,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/nelson-flores-y_yKkAYsQRQ-unsplash%20(1).jpg"
                alt="Cactus"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Treatments Grid Section */}
      <section className="bg-[#F8F5F2] py-40">
        <div className="max-w-4xl mx-auto px-6 text-center mb-28">
          <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-12 tracking-tight">
            Treatments
          </h2>
          <div className="w-32 h-[2px] bg-[#C4A092] mx-auto"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Treatment 1 - Neuromodulators */}
            <div className="bg-brand-sage/30 min-h-[700px] flex flex-col rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]">
              <div className="flex-1 flex items-center justify-center p-12">
                <div className="w-64 h-80 rounded-full overflow-hidden shadow-xl">
                  <img
                    src="https://static.wixstatic.com/media/35f824_755cbbef9fb04db4ac9a4071b3b6ccb8~mv2.jpg/v1/fill/w_248,h_347,fp_0.49_0.52,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/jimmy-fermin-bqe0J0b26RQ-unsplash.jpg"
                    alt="Neuromodulators"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="p-12 text-center bg-white">
                <h3 className="font-display text-3xl font-bold text-[#1A1A1A] mb-5 tracking-tight">
                  Neuromodulators
                </h3>
                <p className="font-sans text-base text-[#1A1A1A]/70 leading-[1.7] font-medium">
                  Prevent and smooth fine lines and wrinkles over time
                </p>
              </div>
            </div>

            {/* Treatment 2 - Dermal Fillers */}
            <div className="bg-brand-dusty-pink/50 min-h-[700px] flex flex-col rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]">
              <div className="flex-1 flex items-center justify-center p-12">
                <div className="w-64 h-80 rounded-full overflow-hidden shadow-xl">
                  <img
                    src="https://static.wixstatic.com/media/c837a6_f9dd7374a1984e158800ffc88555537e~mv2.jpg/v1/crop/x_118,y_153,w_328,h_460/fill/w_248,h_347,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Group%20161_edited_edited.jpg"
                    alt="Dermal Fillers"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="p-12 text-center bg-white">
                <h3 className="font-display text-3xl font-bold text-[#1A1A1A] mb-5 tracking-tight">
                  Dermal Fillers
                </h3>
                <p className="font-sans text-base text-[#1A1A1A]/70 leading-[1.7] font-medium">
                  Volume restoration, enhancement, and balance
                </p>
              </div>
            </div>

            {/* Treatment 3 - Weight Loss */}
            <div className="bg-brand-sage/30 min-h-[700px] flex flex-col rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]">
              <div className="flex-1 flex items-center justify-center p-12">
                <div className="w-64 h-80 rounded-full overflow-hidden shadow-xl">
                  <img
                    src="https://static.wixstatic.com/media/35f824_b31d1cafb471454ba7151f3500f26cd3~mv2.jpg/v1/crop/x_1045,y_2219,w_2176,h_3047/fill/w_247,h_347,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/julia-rekamie-Z72YujnOrlY-unsplash.jpg"
                    alt="Weight Loss"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="p-12 text-center bg-white">
                <h3 className="font-display text-3xl font-bold text-[#1A1A1A] mb-5 tracking-tight">
                  Weight Loss
                </h3>
                <p className="font-sans text-base text-[#1A1A1A]/70 leading-[1.7] font-medium">
                  Preserve lean muscle while losing fat
                </p>
              </div>
            </div>

            {/* Treatment 4 - IV Therapy */}
            <div className="bg-brand-dusty-pink/50 min-h-[700px] flex flex-col rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]">
              <div className="flex-1 flex items-center justify-center p-12">
                <div className="w-64 h-80 rounded-full overflow-hidden shadow-xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20IV%20therapy%20treatment%20in%20luxury%20medical%20spa%20setting%2C%20elegant%20wellness%20infusion%20therapy%2C%20premium%20aesthetic%20clinic%20interior%2C%20sophisticated%20medical%20drip%20treatment%2C%20clean%20minimalist%20healthcare%20environment%2C%20warm%20neutral%20tones%2C%20professional%20medical%20aesthetic%20atmosphere%2C%20high-end%20wellness%20therapy%2C%20serene%20treatment%20room%20with%20modern%20medical%20equipment&width=248&height=347&seq=iv-therapy-treatment-001&orientation=portrait"
                    alt="IV Therapy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="p-12 text-center bg-white">
                <h3 className="font-display text-3xl font-bold text-[#1A1A1A] mb-5 tracking-tight">
                  IV Therapy
                </h3>
                <p className="font-sans text-base text-[#1A1A1A]/70 leading-[1.7] font-medium">
                  Boost hydration, energy, and overall wellness
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-white py-40">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-28">
            <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-8 tracking-tight">
              Frequently Asked
            </h2>
            <p className="font-display italic text-2xl text-[#C4A092] font-normal">Questions &amp; Answers</p>
            <div className="w-32 h-[2px] bg-[#C4A092] mx-auto mt-12"></div>
          </div>

          <div className="space-y-6">
            {/* FAQ Item 1 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  What should I expect during my first consultation?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  During your first visit, Sydney will discuss your aesthetic goals, review your medical history, and perform a facial assessment. Together, you&apos;ll create a personalized treatment plan tailored to your unique features and desired outcomes. There&apos;s no pressure to proceed with treatment on the same day.
                </p>
              </div>
            </details>

            {/* FAQ Item 2 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  How long do injectable treatments typically last?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  Neuromodulators like Dysport typically last 3-4 months, while dermal fillers can last anywhere from 6-18 months depending on the product used and treatment area. Lip fillers generally last 6-12 months, and cheek or chin fillers can last up to 18 months. Results vary based on individual metabolism and lifestyle factors.
                </p>
              </div>
            </details>

            {/* FAQ Item 3 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  What is the aftercare for lip filler treatments?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  After lip filler, avoid strenuous exercise for 24-48 hours, skip alcohol for 24 hours, and don&apos;t apply makeup to the treated area for at least 4 hours. Apply ice gently to reduce swelling, stay hydrated, and avoid extreme heat (saunas, hot yoga) for 48 hours. Some swelling and bruising is normal and typically resolves within 1-2 weeks.
                </p>
              </div>
            </details>

            {/* FAQ Item 4 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  Is there any downtime after Dysport or neuromodulator treatments?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  There&apos;s minimal to no downtime with Dysport. You can return to normal activities immediately, but avoid lying down for 4 hours post-treatment and skip intense workouts for 24 hours. Don&apos;t rub or massage the treated areas. Results begin to appear within 2-5 days and full effects are visible at 2 weeks.
                </p>
              </div>
            </details>

            {/* FAQ Item 5 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  What should I avoid before my injectable appointment?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  To minimize bruising, avoid blood-thinning medications (aspirin, ibuprofen), fish oil, vitamin E, and alcohol for at least 48 hours before your appointment. If you&apos;re on prescription blood thinners, consult your physician before stopping. Arrive with a clean face, free of makeup on the treatment area.
                </p>
              </div>
            </details>

            {/* FAQ Item 6 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  How do the weight loss injections work?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  Semaglutide and Tirzepatide are GLP-1 receptor agonists that help regulate appetite, slow gastric emptying, and improve insulin sensitivity. They&apos;re administered as weekly injections and work best when combined with a healthy diet and regular exercise. During your consultation, we&apos;ll determine the right protocol and dosage for your goals.
                </p>
              </div>
            </details>

            {/* FAQ Item 7 */}
            <details className="group bg-[#F8F5F2] rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <summary className="flex items-center justify-between p-10 cursor-pointer list-none">
                <h4 className="font-display text-xl font-bold text-[#1A1A1A] pr-8 tracking-tight">
                  What is the aftercare for laser hair removal?
                </h4>
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A092]/10 group-open:bg-[#C4A092] transition-colors duration-300">
                  <i className="ri-add-line text-[#C4A092] group-open:hidden text-2xl w-6 h-6 flex items-center justify-center"></i>
                  <i className="ri-subtract-line text-white hidden group-open:block text-2xl w-6 h-6 flex items-center justify-center"></i>
                </span>
              </summary>
              <div className="px-10 pb-10">
                <p className="font-sans text-base text-[#1A1A1A]/75 leading-[1.8] font-medium">
                  After laser hair removal, avoid sun exposure and tanning for at least 2 weeks. Apply aloe vera or a gentle moisturizer to soothe the treated area. Avoid hot showers, saunas, and intense exercise for 24-48 hours. Don&apos;t wax or pluck between sessions—shaving is fine. Most clients need 6-8 sessions spaced 4-6 weeks apart for optimal results.
                </p>
              </div>
            </details>
          </div>

          <div className="text-center mt-24">
            <p className="font-sans text-base text-[#1A1A1A]/70 mb-10 font-medium">
              Have more questions? We&apos;re here to help.
            </p>
            <a
              href="tel:+17022835858"
              className="inline-block px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-lg hover:shadow-xl hover:scale-105"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Instagram Showcase Section */}
      <section className="bg-[#F8F5F2] py-40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-28">
            <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-10 tracking-tight">
              Follow Along
            </h2>
            <p className="font-display italic text-2xl text-[#C4A092] mb-2 font-normal">@theinjectorsyd</p>
            <div className="w-32 h-[2px] bg-[#C4A092] mx-auto mt-12"></div>
          </div>

          {/* Instagram Embeds Grid with Glow Effect */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-24">
            {/* Embed 1 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-[#C4A092] via-brand-dusty-pink to-brand-sage rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/DTjRd9OASN7/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Post 1"
                ></iframe>
              </div>
            </div>

            {/* Embed 2 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-brand-dusty-pink via-[#C4A092] to-brand-sage rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/DJW19MfpM8p/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Post 2"
                ></iframe>
              </div>
            </div>

            {/* Embed 3 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-brand-sage via-brand-dusty-pink to-[#C4A092] rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/DSAhp1kjzA1/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Post 3"
                ></iframe>
              </div>
            </div>

            {/* Embed 4 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-[#C4A092] via-brand-sage to-brand-dusty-pink rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/reel/DJUoCeXS8dG/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Reel 4"
                ></iframe>
              </div>
            </div>

            {/* Embed 5 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-brand-dusty-pink via-brand-sage to-[#C4A092] rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/C9REi0ERkHR/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Post 5"
                ></iframe>
              </div>
            </div>

            {/* Embed 6 */}
            <div className="group relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-brand-sage via-[#C4A092] to-brand-dusty-pink rounded-3xl opacity-40 blur-xl group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-white shadow-lg">
                <iframe
                  src="https://www.instagram.com/reel/C8Uyn7TPuzt/embed/captioned/?hidecaption=true"
                  className="w-[calc(100%+120px)] h-[calc(100%+200px)] border-0 -ml-[60px] -mt-[60px]"
                  scrolling="no"
                  allowTransparency="true"
                  title="Instagram Reel 6"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Follow Button */}
          <div className="text-center">
            <a
              href="https://www.instagram.com/theinjectorsyd/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-4 px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-lg hover:shadow-xl hover:scale-105"
            >
              <i className="ri-instagram-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              Follow Us on Instagram
            </a>
          </div>
        </div>
      </section>

      {/* Ready to Feel Your Best CTA Section */}
      <section className="bg-white py-40">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-display text-7xl md:text-8xl font-bold text-[#1A1A1A] mb-14 tracking-tight leading-[1.1]">
            Ready to Feel<br />Your Best?
          </h2>
          <p className="font-display italic text-2xl text-[#C4A092] mb-16 font-normal">
            Begin your aesthetic journey with a personalized consultation
          </p>
          <a
            href="tel:+17022835858"
            className="inline-block px-14 py-6 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl hover:scale-105"
          >
            Schedule Your Consultation
          </a>
        </div>
      </section>

      {/* Palm Trees Bottom Section */}
      <section className="relative w-full">
        <img
          src="https://static.wixstatic.com/media/f102399b227b4cb9a99a0bd552240528.jpg/v1/fill/w_1280,h_676,fp_0.50_0.60,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Palm%20Trees.jpg"
          alt="Palm Trees"
          className="w-full h-[500px] object-cover"
        />
      </section>

      {/* Footer */}
      <footer className="bg-[#E5D5CF] py-28">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-20 mb-20">
            {/* Column 1 - Home & Menu */}
            <div>
              <nav className="mb-10">
                <Link
                  to="/"
                  className="block font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-6 hover:text-[#C4A092] cursor-pointer transition-colors"
                >
                  Home
                </Link>
              </nav>
              <Link
                to="/menu"
                className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] hover:text-[#C4A092] cursor-pointer transition-colors"
              >
                Menu
              </Link>
            </div>

            {/* Column 2 - Address */}
            <div>
              <p className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-8">
                Our Address
              </p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=6040+W+Badura+Ave+Ste+100+Las+Vegas+NV+89118"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-sans text-base text-[#1A1A1A]/75 hover:text-[#C4A092] cursor-pointer transition-colors font-medium"
              >
                <p className="font-semibold text-[#1A1A1A]">Inside Thriverock Medicine 3.0</p>
                <p className="mt-4">6040 W Badura Ave</p>
                <p>Ste 100</p>
                <p>Las Vegas, NV 89118</p>
              </a>
              <div className="font-sans text-base text-[#1A1A1A]/75 mt-8 space-y-3 font-medium">
                <p>
                  <a href="tel:+17022835858" className="hover:text-[#C4A092] cursor-pointer transition-colors">
                    702-283-5858
                  </a>
                </p>
                <p>
                  <a href="mailto:info@theinjectorsyd.com" className="hover:text-[#C4A092] cursor-pointer transition-colors">
                    info@theinjectorsyd.com
                  </a>
                </p>
              </div>
            </div>

            {/* Column 3 - Hours */}
            <div>
              <p className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-8">
                Open Hours
              </p>
              <div className="font-sans text-base text-[#1A1A1A]/75 space-y-3 font-medium">
                <p>Daily: 7 AM - 7 PM</p>
                <p className="mt-4 font-semibold text-[#1A1A1A]">By Appointment Only</p>
              </div>
            </div>

            {/* Column 4 - Instagram */}
            <div>
              <a
                href="https://www.instagram.com/theinjectorsyd"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] hover:text-[#C4A092] cursor-pointer transition-colors"
              >
                <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
                Instagram
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-center pt-12 border-t border-[#1A1A1A]/10">
            <p className="font-sans text-sm text-[#1A1A1A]/70 font-medium">© 2024 The Injector Syd</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-sm text-[#1A1A1A]/50 hover:text-[#C4A092] cursor-pointer mt-4 inline-block transition-colors font-medium"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Fixed CTA Button */}
      <div className="fixed bottom-10 left-1/2 transform -translate-x-1/2 z-50">
        <a
          href="tel:+17022835858"
          className="inline-block px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl rounded-lg hover:scale-105"
        >
          Call or Text to Book
        </a>
      </div>
    </div>
  );
}
